(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.championships.championship.draw
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.draw', [
      'ui.router'
    ]);
}());
